import { useTranslation } from 'react-i18next'
import { BtModal } from '@linqpal/components/src/ui'
import { BtModalHeader } from '../../../../../ui/atoms/BtModalHeader'
import { StyleSheet, View } from 'react-native'
import React from 'react'
import { ILoanPaymentPlanModel } from '@linqpal/models'
import { IDownPaymentDetails } from '@linqpal/models/src/types/routes'
import { InvoiceCreditPaymentForm } from './InvoiceCreditPaymentForm'

interface IProps {
  invoiceIds: string[]
  paymentPlan: ILoanPaymentPlanModel
  downPayment: IDownPaymentDetails | null
  navigation?: any
  onBack: () => void
  onClose: () => void
  onSuccess: () => void
}

export const InvoiceCreditPaymentModal = ({
  invoiceIds,
  paymentPlan,
  downPayment,
  navigation,
  onBack,
  onClose,
  onSuccess,
}: IProps) => {
  const { t } = useTranslation('global')

  return (
    <BtModal
      visible={true}
      customHeader={
        <BtModalHeader
          title={t('payInvoice.pay-invoice')}
          onBack={onBack}
          onClose={onClose}
        />
      }
    >
      <View style={styles.wrapper}>
        <InvoiceCreditPaymentForm
          invoiceIds={invoiceIds}
          paymentPlan={paymentPlan}
          downPayment={downPayment}
          navigation={navigation}
          onSuccess={onSuccess}
        />
      </View>
    </BtModal>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    marginHorizontal: 10,
  },
})
